import { Button, Layout, Menu, theme } from 'antd';
import { Content, Header } from 'antd/es/layout/layout';
import React from 'react';
import logo from './../../assets/images/cybergold.svg'
import css from './Admin.module.css'
import Books from '../../Pages/Admin/Books/Books';
import { LogoutOutlined } from '@ant-design/icons';
import { NavLink, Route, Routes, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Videos } from "../../Pages/Admin/Videos/Videos";
import { Authors } from "../../Pages/Admin/Authors/Authors";
import { Cats } from "../../Pages/Admin/Cats/Cats";
import { API_URL } from "../../Constants";
import useSignOut from "react-auth-kit/hooks/useSignOut";
import Posts from '../../Pages/Admin/Posts/Posts';
import VideoCat from '../../Pages/Admin/VideoCat/VideoCat';
import PostCat from '../../Pages/Admin/PostCat/PostCat';
import AudioCat from '../../Pages/Admin/AudioCat/AudioCat';
import { Audios } from '../../Pages/Admin/Audios/Audios';
import Nashr from '../../Pages/Admin/Nashr/Nashr';
import Langs from '../../Pages/Admin/Langs/Langs';
import Messages from '../../Pages/Admin/Messages/Messages';

function Admin(props) {
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();
    axios.defaults.baseURL = API_URL

    let signout = useSignOut()
    let navigate = useNavigate()
    axios.interceptors.request.use(function (config) {
        // Do something before request is sent
        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        return Promise.reject(error);
    });
    return (
        <Layout className={css.admin}>
            <Header
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                    <img src={logo} height={50} alt="" />
                </div>
                <Menu
                    theme="dark"
                    mode="horizontal"
                    defaultSelectedKeys={['1']}
                    items={[
                        {
                            key: 1,
                            label: <NavLink to={'/dash/'}>Kitoblar</NavLink>,
                        },
                        {
                            key: 2,
                            label: <NavLink to={'/dash/posts'}>Maqolalar</NavLink>,
                        },

                        {
                            key: 3,
                            label: <NavLink to={'/dash/videos'}>Videolar</NavLink>,
                        },
                        {
                            key: 'a3',
                            label: <NavLink to={'/dash/audios'}>Audiolar</NavLink>,
                        },
                        {
                            key: 'm4',
                            label: <NavLink to={'/dash/messages'}>Xabarlar</NavLink>,
                        },
                        {
                            key: 4,
                            label: "Sozlamalar",
                            children: [
                                {
                                    key: 41,
                                    label: <NavLink to={'/dash/bookautors'}>Kitob Mualliflari</NavLink>
                                },
                                {
                                    key: 49,
                                    label: <NavLink to={'/dash/nashr'}>Nashriyotlar</NavLink>
                                },
                                {
                                    key: 48,
                                    label: <NavLink to={'/dash/langs'}>Tillar</NavLink>
                                },
                                {
                                    key: 42,
                                    label: <NavLink to={'/dash/bookcats'}>Kitoblar Kategoriyalari</NavLink>
                                },
                                {
                                    key: 43,
                                    label: <NavLink to={'/dash/videocats'}>Videolar Kategoriyalari</NavLink>
                                },
                                {
                                    key: 'a43',
                                    label: <NavLink to={'/dash/audiocats'}>Audiolar Kategoriyalari</NavLink>
                                },
                                {
                                    key: 44,
                                    label: <NavLink to={'/dash/postcats'}>Maqolalar Kategoriyalari</NavLink>
                                },

                            ]
                        }
                    ]}
                    style={{
                        flex: 1,
                        minWidth: 0,
                    }}
                />
                <Button icon={<LogoutOutlined />} onClick={() => {
                    signout()
                    navigate('/')
                }} type='primary' danger />
            </Header>
            <Content
                style={{
                    padding: '0 48px',
                }}
            >
                <div
                    style={{
                        background: colorBgContainer,
                        padding: 20,
                        borderRadius: borderRadiusLG,
                        minHeight: '650px'
                    }}
                >
                    <Routes>
                        <Route path={'/'} element={<Books />} />
                        <Route path={'/posts'} element={<Posts />} />
                        <Route path={'/audios'} element={<Audios />} />
                        <Route path={'/videos'} element={<Videos />} />
                        <Route path={'/bookautors'} element={<Authors />} />
                        <Route path={'/bookcats'} element={<Cats />} />
                        <Route path={'/videocats'} element={<VideoCat />} />
                        <Route path={'/audiocats'} element={<AudioCat />} />
                        <Route path={'/postcats'} element={<PostCat />} />
                        <Route path={'/nashr'} element={<Nashr />} />
                        <Route path={'/langs'} element={<Langs />} />
                        <Route path={'/messages'} element={<Messages />} />
                    </Routes>

                </div>
            </Content>
        </Layout>
    );
}

export default Admin;